import { z } from 'zod';

// Messages are keys in locales/en/messages.json; the form showing the error
// translates them (t(message, { ns: 'messages' })).

// Authentication Schema
export const authSchema = z.object({
  email: z.string()
    .email('validation.invalidEmail')
    .max(255, 'validation.emailTooLong')
    .trim()
    .toLowerCase(),
  password: z.string()
    .min(1, 'validation.passwordRequired')
    .max(72, 'validation.passwordTooLong')
});

// Broker API Key Schema
export const brokerKeySchema = z.object({
  passKey: z.string()
    .min(10, 'validation.apiKeyTooShort')
    .max(500, 'validation.apiKeyTooLong')
    .trim(),
  secretKey: z.string()
    .min(10, 'validation.secretTooShort')
    .max(500, 'validation.secretTooLong')
    .trim(),
  passphrase: z.string()
    .max(100, 'validation.passphraseTooLong')
    .optional()
    .or(z.literal('')),
  isTestnet: z.boolean()
});

// Model Configuration Schema
export const modelConfigSchema = z.object({
  name: z.string()
    .min(1, 'validation.nameRequired')
    .max(100, 'validation.nameTooLong')
    .trim(),
  walletSize: z.object({
    type: z.enum(['maxPressure', 'fixedAmount']),
    fixedAmount: z.number()
      .positive('validation.mustBePositive')
      .max(1000000000, 'validation.unrealisticWallet')
      .optional(),
    marginCap: z.number()
      .min(0, 'validation.cannotBeNegative')
      .max(100, 'validation.max100')
      .optional(),
    marginType: z.enum(['crossed', 'isolated'])
  }),
  leverage: z.object({
    type: z.string(),
    value: z.number()
      .min(1, 'validation.minLeverage')
      .max(125, 'validation.maxLeverage')
      .optional()
  }),
  maxSimultaneousTrades: z.number()
    .int('validation.wholeNumber')
    .positive('validation.mustBePositive')
    .optional(),
  directionSpecific: z.object({
    longOnly: z.boolean(),
    shortOnly: z.boolean()
  }).optional(),
  blockedAssets: z.array(z.string()).optional(),
  allowedAssets: z.array(z.string()).optional(),
  skipWhenMarketClosed: z.boolean().optional(),
  killSwitch: z.object({
    pnl: z.number().min(0, 'validation.killSwitchPnl').optional(),
    drawdown: z.number()
      .min(0, 'validation.cannotBeNegative')
      .max(100, 'validation.max100')
      .optional(),
    losingStreak: z.number()
      .int('validation.wholeNumber')
      .positive('validation.mustBePositive')
      .optional()
  }).optional(),
  orders: z.any().optional(),
  trailingStop: z.any().optional()
});
